import { getTagFromResource } from "@examspark/common";
import {
  Objective,
  ObjectivesItem,
  TeksCategory,
  TeksCurriculumUsage,
} from "@examspark/types";

export type TeksObjectiveType =
  | "knowledge_statement"
  | "student_expectation"
  | "romanette";

export const getObjectiveCurriculumUsage = (
  objectivesItem:
    | Pick<ObjectivesItem, "__typename" | "tags">
    | null
    | undefined,
) =>
  getTagFromResource<TeksCurriculumUsage>(
    objectivesItem,
    "tcmpc-teks-curriculum-usage",
  )?.value;

export const getObjectiveCategory = (
  objective: Pick<Objective, "__typename" | "tags"> | null | undefined,
): TeksCategory | undefined => {
  const category =
    getTagFromResource<TeksCategory>(objective, "tcmpc-teks-category")?.value ??
    "";

  // ensure category is a valid TeksCategory
  const categoryList: TeksCategory[] = [
    "PROCESS",
    "READINESS",
    "SUPPORTING",
    "RTC",
    "SEP",
  ];
  if (category && categoryList.includes(category)) {
    return category;
  }

  return undefined;
};

export const getObjectiveType = (
  objective: Pick<Objective, "abbreviation">,
): TeksObjectiveType | undefined => {
  const parts = objective.abbreviation?.split(".");
  const length = parts?.length;

  if (!length) return undefined;
  if (length === 2) return "knowledge_statement";
  if (length === 3) return "student_expectation";
  if (length >= 4) return "romanette";

  return undefined;
};
